import { useQuery } from "@tanstack/react-query";
import { authService } from "@/services/authService";
import useAuth from "@/hooks/stores/useAuth";
import { userService } from "@/services/userService"; 



export const userQueryKey = "profile";

export const useUser = () => {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: [userQueryKey, isAuthenticated],
    queryFn: () => authService.getProfile(),
    enabled: isAuthenticated,
  });
};



// query keys
export const userQueryKeys = {
  all: ["users" ],
  list: (params) => [...userQueryKeys.all, "list", params],
  details: (id) => [...userQueryKeys.all, "detail", id],
};

// get all users
export const useAllUsers = (params) => {
  return useQuery({
    queryKey: userQueryKeys.list(params),
    queryFn: () => userService.getAllUsers(params),
  });
};

// view user
export const useViewUser = (userId) => {
  return useQuery({
    queryKey: userQueryKeys.details(userId),
    queryFn: () => userService.viewUser(userId),
  });
};